import { useCallback, useState } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { useTranslation } from "@coworker/locales";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

type TitledTextWithModalProps = {
  title: string;
  description: string;
  modalContent: React.ReactNode;
  modalTitle?: string;
  onConfirm?: () => void;
  testId?: string;
};

function TitledTextWithModal({
  title,
  description,
  modalContent,
  modalTitle,
  onConfirm,
  testId,
}: TitledTextWithModalProps) {
  const { t } = useTranslation();
  const headerId = "task-management-titled-text-with-modal-header";
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm();
    }
    handleCloseModal();
  }, [onConfirm, handleCloseModal]);

  return (
    <>
      <FixaListViewItem
        title={title}
        emphasised={true}
        inset
        onClick={handleOpenModal}
        description={description}
        control="navigational"
        controlIcon={null}
        data-testid={testId}
      />
      <FixaModal visible={showModal} handleCloseBtn={handleCloseModal}>
        <FixaSheets
          labelledById={headerId}
          header={
            <FixaModalHeader
              id={headerId}
              title={modalTitle || title}
              closeBtnClick={handleCloseModal}
            />
          }
          footer={
            <FixaModalFooter renderBorder>
              <FixaButton
                type="primary"
                fluid
                text={t("confirmString")}
                onClick={handleConfirm}
              />
            </FixaModalFooter>
          }
          fullSize
        >
          <FixaModalBody>{modalContent && modalContent}</FixaModalBody>
        </FixaSheets>
      </FixaModal>
    </>
  );
}

export default TitledTextWithModal;
